const initialState = {
  hasFetched: false,
  listingToFetch: '',
  data: {},
  fetchError: null,
  isPatching: false
};

export default function listing (state = initialState, action) {
  const { listingToFetch, data, fetchError, type, updateError, isPatching } = action;

  if ('LISTING_CLEAR_STORE' === type) {
    return { ...initialState };
  }

  if ('LISTING_FETCH_REQUEST' === type) {
    return { ...state, listingToFetch };
  }

  if ('LISTING_FETCH_SUCCESS' === type) {
    return { ...state, data, hasFetched: true };
  }

  if ('LISTING_FETCH_FAILURE' === type) {
    return { ...state, fetchError, hasFetched: true };
  }

  if ('LISTING_UPDATE_REQUEST' === type) {
    return { ...state, isPatching };
  }

  if ('LISTING_UPDATE_SUCCESS' === type) {
    return { ...state, isPatching };
  }

  if ('LISTING_UPDATE_FAILURE' === type) {
    return { ...state, updateError, isPatching };
  }

  return state;
}
